module.exports = __webpack_public_path__ + "img/25.3ce1d4be.png";